import React from 'react';
import { Card } from '@core-ui/Components/ui/card.tsx';
import { IconInfoCircle } from '@tabler/icons-react';

export default function JobLogs (): React.JSX.Element {
  return (
    <Card className="gap-1 rounded-xl bg-red-500/10 text-red-700 border border-red-500/30 dark:text-red-300 mt-4 ml-4 mr-4 p-3">
      <div className="flex items-center gap-1">
        <IconInfoCircle className="w-3 h-3" />
        <span className="text-sm leading-tight pr-3">*</span>
      </div>
      <div className="gap-1 rounded-xl bg-red-500/10 text-red-700 dark:text-red-300 pl-2">
        *
      </div>
    </Card>
  );
}